import React from 'react';
import styles from './userReadingListPageStyles.scss';

import ReadingListIdeasContainer from 'buyside/components/container/UserAccount/ReadingListIdeasContainer';

const UserReadingListPage: React.FC<{
  archivedPage?: boolean;
}> = ({ archivedPage }): React.ReactElement => {
  return (
    <>
      <div className={styles.pageTitle}>Your {archivedPage ? 'Archived' : ''} Reading List</div>
      <ReadingListIdeasContainer archivedPage={Boolean(archivedPage)} />
    </>
  );
};

export default UserReadingListPage;
